import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/site";

const NewsletterForm = ({ dark = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email: email.trim() });
      toast.success(res.data.message || "Thanks for subscribing.");
      setEmail("");
    } catch (err) {
      toast.error("Sorry, something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-3 w-full" data-testid="newsletter-form">
      <label htmlFor={dark ? "newsletter-email-footer" : "newsletter-email"} className="sr-only">
        Email address
      </label>
      <input
        id={dark ? "newsletter-email-footer" : "newsletter-email"}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        data-testid="newsletter-email-input"
        className={`flex-1 rounded-full px-5 py-3 text-base outline-none transition-shadow duration-200 focus-visible:ring-2 focus-visible:ring-waratah ${
          dark ? "bg-white/10 text-white placeholder:text-white/60 border border-white/20" : "bg-white text-navy placeholder:text-slate-400 border border-navy-100"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-button"
        className="rounded-full bg-waratah px-6 py-3 text-base font-semibold text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-waratah-600 hover:shadow-md disabled:opacity-60 disabled:hover:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {loading ? "Subscribing..." : "Subscribe"}
      </button>
    </form>
  );
};

export default NewsletterForm;
